import app from '../app';
import Component from '../Component';
import Button from './Button';
import classList from '../utils/classList';
/**
 * Choose or remove an image to show instead of a model's Font Awesome icon.
 * The change is held in `state` until the form saves it.
 */
export default class IconImageInput extends Component {
  static ACCEPT = 'image/png,image/jpeg,image/gif,image/webp,image/bmp';
  view(vnode) {
    const {
      state,
      id,
      className
    } = vnode.attrs;
    const url = state.url();
    return m("div", {
      className: classList('IconImageInput', className)
    }, url && m("img", {
      className: "IconImageInput-preview",
      src: url,
      srcset: state.srcset() || undefined,
      alt: ""
    }), m("input", {
      type: "file",
      id: id,
      className: "IconImageInput-file",
      accept: IconImageInput.ACCEPT,
      onchange: e => {
        const input = e.target;
        const file = input.files?.[0];
        if (file) state.set(file);

        // Clear the input so choosing the same file again still fires.
        input.value = '';
      }
    }), m(Button, {
      className: "Button",
      icon: "fas fa-upload",
      onclick: () => this.choose()
    }, url ? app.translator.trans('core.lib.icon_image_input.replace_button') : app.translator.trans('core.lib.icon_image_input.upload_button')), url && m(Button, {
      className: "Button Button--danger",
      icon: "fas fa-times",
      onclick: () => state.remove()
    }, app.translator.trans('core.lib.icon_image_input.remove_button')));
  }
  choose() {
    this.element.querySelector('.IconImageInput-file').click();
  }
}
flarum.reg.add('core', 'common/components/IconImageInput', IconImageInput);